<template>
  <PageLayout>
    <template v-slot:header>
      <div class="ui padded grid">
        <div class="row">
          <div class="sixteen wide column">
            <Breadcrumb>
              <router-link class="section" to="/contracts">
                Contratos
              </router-link>
              <i class="right chevron icon divider"></i>
              <div class="active section">
                <div class="neutral">Auditoria de Contrato</div>
              </div>
            </Breadcrumb>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:main>
      <div class="ui padded grid">
        <div class="row">
          <div class="sixteen wide column">
            <form
              class="ui small form"
              @submit.prevent="fetch"
              v-autocomplete-off
            >
              <div class="fields">
                <div class="four wide field">
                  <label for="cotracts-audit-number">
                    Código do contrato
                  </label>
                  <input
                    autofocus
                    type="text"
                    id="cotracts-audit-number"
                    v-model="form.contract_id"
                  />
                </div>
                <div class="end field">
                  <input
                    type="submit"
                    name="commit"
                    value="Filtrar"
                    class="ui button"
                  />
                </div>
              </div>
            </form>
            <div v-show="loading" class="ui active inverted dimmer">
              <div class="ui text loader">Carregando...</div>
            </div>
            <table class="ui striped table">
              <thead>
                <tr>
                  <th></th>
                  <th>Data</th>
                  <th>Cadastro</th>
                  <th>Código</th>
                  <th>Evento</th>
                  <th>Descrição</th>
                  <th>Usuário</th>
                </tr>
              </thead>
              <tbody>
                <div
                  class="neutral"
                  v-for="(version, index) in versions"
                  :key="index"
                >
                  <tr>
                    <td class="center aligned">
                      <a
                        v-show="Object.keys(version.item_changes).length > 0"
                        @click.prevent="open_details($event)"
                        ><i class="caret right icon"></i
                      ></a>
                    </td>
                    <td>
                      {{ getFormattedDate(version.created_at) }}
                    </td>
                    <td>{{ version.group }}</td>
                    <td>{{ id(version) }}</td>
                    <td>{{ getEventEnum(version.event) }}</td>
                    <!-- <td>{{ (version.who || {})['name'] }}</td> -->
                    <td>{{ version.message }}</td>
                    <td>{{ (version.who || {})['username'] }}</td>
                  </tr>
                  <tr class="details hide">
                    <td colspan="6">
                      <div class="ui segment">
                        <table class="ui very basic table">
                          <thead>
                            <th>Campo</th>
                            <th>Antes</th>
                            <th>Depois</th>
                          </thead>
                          <tbody>
                            <div class="neutral">
                              <tr
                                v-for="change_key in Object.keys(
                                  version.item_changes
                                )"
                                :key="change_key"
                              >
                                <td class="bold">{{ change_key }}</td>
                                <td>
                                  {{ version.item_changes[change_key][0] }}
                                </td>
                                <td>
                                  {{ version.item_changes[change_key][1] }}
                                </td>
                                <td></td>
                              </tr>
                            </div>
                          </tbody>
                        </table>
                      </div>
                    </td>
                  </tr>
                </div>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </template>
  </PageLayout>
</template>

<script>
import Api from '@/resources/Api';
import Breadcrumb from '@/components/breadcrumb';
import PageLayout from '@/layouts/page_layout';
import historyEnum from '@/enumerations/history_enum.js';

export default {
  name: 'services',
  components: { Breadcrumb, PageLayout },

  data() {
    return {
      loading: false,
      form: {
        contract_id: null
      },
      versions: []
    };
  },

  // mounted() {
  //   // this.fetch(this.$route.params.contract_id);
  // },

  methods: {
    who(version) {
      return version.who ? version.who['username'] : '';
    },

    id(version) {
      return version.group == 'Parcela'
        ? version.item_obj?.number || version.item_changes.number[1] || ''
        : version.item_id;
    },

    fetch() {
      this.loading = true;
      Api.contracts
        .audit_report(this.form.contract_id)
        .then(async response => {
          this.versions = response.data.versions;
        })
        .catch(error => {
          if (error.response) {
            this.$toast.show('Erro ao buscar contrato', 'error');
          } else {
            throw error;
          }
        })
        .finally(() => {
          this.$scrollTop();
          this.loading = false;
        });
    },

    open_details(evt) {
      var $icon = window.$(evt.target);
      var $details = $icon.closest('tr').next('tr.details');
      if ($icon.hasClass('right')) {
        $icon.removeClass('right');
        $icon.addClass('down');

        $details.removeClass('hide');
      } else {
        $icon.removeClass('down');
        $icon.addClass('right');

        $details.addClass('hide');
      }
    },

    getEventEnum(event) {
      const { description } = historyEnum.events.find(
        eventFind => eventFind.value === event
      );
      return description;
    },

    getRegisterDescription(register) {
      const description = historyEnum.registers.find(
        registerFind => registerFind.value === register
      )?.description;
      return description;
    },

    getEventDescription(evt) {
      const description = historyEnum.events.find(
        eventFind => eventFind.value === evt
      )?.description;
      return description;
    },

    getFormattedDate(date) {
      const formattedDate = this.$moment(date)
        .locale('pt')
        .format('ddd[,] DD [de] MMMM [de] YYYY[,] HH:mm:ss');
      return formattedDate;
    }
  }
};
</script>
